import { Component, Inject, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FlowControlService } from '../../../digitalvenue/services/flow-control.service';
import { DjangoSessionAuthenticationService, ThemeSelectorService, UserService } from '../../../services';
import { Router } from '@angular/router';
import { APIConnectionService } from '../../../digitalvenue/services/api-connection.service';
import { CustomerPlan } from '../../models';
import { ChoiceAddonConfig } from '../../../choice-flow/choice.configuration';
import { ChoiceItem } from '../../../choice-flow/choice-configuration.model';
import { ConfigurationService } from '../../../services/configuration.service';
import { ModalsService } from '../modals.service';

@Component({
  selector: 'app-twins-flex-addons-modal',
  templateUrl: './twins-choice-addons-modal.component.html',
  styleUrls: ['./twins-choice-addons-modal.component.scss']
})
export class TwinsChoiceAddonsModalComponent implements OnInit {
  isDarkTheme: boolean;

  constructor(public bsModalRef: BsModalRef,
              public flowControl: FlowControlService,
              private router: Router,
              private userService: UserService,
              private connectionService: APIConnectionService,
              private modalService: ModalsService,
              private configService: ConfigurationService,
              private authService: DjangoSessionAuthenticationService,
              @Inject(ChoiceAddonConfig) public choiceAddonConfig: ChoiceItem,
              private themeSelector: ThemeSelectorService) {
  }

  @Input() customerPlan: CustomerPlan;
  selectedQuantity: number | null = null;
  numbers: number[];

  ngOnInit() {
    // @ts-ignore
    this.numbers = Array(19).fill().map((x: any, i: number) => i+1); // [0,1,2,3,4]
  }


  /**
   * Hides the modal
   */
  decline(): void {
    this.bsModalRef.hide();
  }

  getTheme() {
    return this.themeSelector.isDarkTheme;
  }

  preSelectQuantity(quantity: number) {
    this.selectedQuantity = quantity;
  }

  onSelectQuantity(quantity: number) {
    this.bsModalRef.hide();
    const priceScaleName = this.choiceAddonConfig.priceScaleName;
    const priceScaleId = this.choiceAddonConfig.priceScaleId;
    const targetPlan = this.choiceAddonConfig.planId;
    const basket = [`Price_scale_name:${priceScaleName}-Price_Scale_id:${priceScaleId}-target_plan:${targetPlan}-quantity:${quantity}`];
    // only one seat
    this.flowControl.seatsToKeep = [this.customerPlan.customer_plan_seats[0].id];
    const transactionSeats = basket.concat(this.flowControl.seatsToKeep);
    this.configService.showLoader(true);
    // if we are adding on current plan we don't want the backend to treat as an upgrade, then if we have
    // addon flex plan don't send this value
    const upgradePlan = this.flowControl.addonFlexPlax ? false : this.flowControl.upgradePlan;
    this.connectionService.createHoldTransaction(this.flowControl.currentPlan, transactionSeats, upgradePlan).subscribe(
      success => {
        this.authService.updateUserData().subscribe(
          userData => {
            const transaction = this.userService.getTransactionByPlanId(this.flowControl.currentPlan);

            // if all ok, redirects to the checkout page with the currentPlan
            const p: number = (this.flowControl.upgradePlan) ?
              this.flowControl.upgradePlan :
              this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.id;
            this.configService.showLoader(false);
            this.router.navigate(['/checkout', this.customerPlan.id]);
          },
          error => {
            this.configService.showLoader(false);
            const errorMessage = error.error;
            this.modalService.errorModal(errorMessage.message);
            // If error, shows a modal with the error code
            // this.errorCodeService.getErrorByCode(1004).subscribe(
            //   errorText => {
            //     // displays an error modal
            //     this.modals.errorModal(errorText);
            //   }
            // );
          }
        );
      },
      error => {
        this.configService.showLoader(false);
        const errorMessage = error.error;
        // Texas Rangers want to catch the error when left 3 seats group.
        // https://mmcbcn.atlassian.net/browse/MMC-14837?focusedCommentId=73660
        if (errorMessage.code === 'pv.cart.50029' && this.configService.client === 'texasrangers') {
          this.modalService.errorModal(`Your selection leaves behind a three seat grouping. Please adjust your selection before proceeding.`);
        } else if (errorMessage.code === 'TCRRS03') {
          // this.isolationService.checkPendingIsolatedSeats();
          // this.isolatedSeatsApiService.setPendingSeats(errorMessage.seats);
          // this.isolatedSeatsApiService.printIsolatedSeats(errorMessage.seats);
          for (let i = 0; i < errorMessage.seats.length; i++) {
            errorMessage.seats[i] = errorMessage.seats[i].split('S_')[1];
          }
          this.modalService.errorModal(`The selected seats are leaving isolated seats: ${errorMessage.seats}`);
        } else {
          this.modalService.errorModal(errorMessage.message);
          // If error, shows a modal with the error code
          // this.errorCodeService.getErrorByCode(1005).subscribe(
          //   errorText => {
          //     // displays an error modal
          //     this.modals.errorModal(errorText);
          //   }
          // );
        }
      }
    );
  }

}
